import { useAppQuery } from 'data/query-client';
import restClient from 'data/restClient';
import { AllessehContentQueryBody } from './useAllessehContentQuery';
import { useAuthToken } from './useAuthToken';

const getOptimizedQuery = (authToken: string, query: AllessehContentQueryBody) =>
  restClient.post<AllessehContentQueryBody>('allesseh/optimizeQuery', query, {
    headers: {
      Authorization: authToken
    }
  });

export const useOptimizeQuery = (query: AllessehContentQueryBody, options?: { enabled: boolean }) => {
  const authToken = useAuthToken();

  return useAppQuery([query], () => getOptimizedQuery(authToken, query), {
    ...options,
    staleTime: 10000,
    cacheTime: 20000
  });
};
